import React from "react"
import {Typography} from "@mui/material";
import {Box} from "@mui/system";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {SosLocation} from "../../../packages/graphql-layer/src";
import {formatDate} from "../../utility/componentUtil";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";

interface Props {
    location?: string | SosLocation,
    propertyName?: string,
    date: string,
    metadataId?: string
}

function CCOLocationDate(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    return <Box my={5}>
        <Box display="flex" alignItems="center">
            {typeof props.location === "string" ? null : <LocationOnIcon fontSize="large"/>}
            <Box marginLeft={1}>
                {typeof props.location === "string" || props.location === undefined ?
                    <Typography fontWeight={'bold'} {...metaDataProperty(isPreview, props.propertyName, props.metadataId)}>
                        {`${props.location ? props.location + (props.date ? ',' : '') : ''} ${props.date ? formatDate(props.date) : ''}`}
                    </Typography>
                    : <React.Fragment>
                        {props.location ? <React.Fragment>
                                <Typography {...metaDataProperty(isPreview, 'properties.name', props.metadataId)}>
                                    {props.location.name}
                                </Typography>
                                <Typography variant="body2" {...metaDataProperty(isPreview, 'properties.address', props.metadataId)}>
                                    {props.location.address}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" {...metaDataProperty(isPreview, 'properties.postcode', props.metadataId)}>
                                    {props.location.postcode}
                                </Typography>
                                <Typography mt={2} fontWeight={'bold'} {...metaDataProperty(isPreview, 'properties.date', props.metadataId)}>{formatDate(props.date)}</Typography>
                            </React.Fragment>
                            : null}
                    </React.Fragment>
                }
            </Box>
        </Box>
    </Box>
}

export default CCOLocationDate